import { Base } from './base';

export class PublicInstitution extends Base {
    PublicInstitutionID?: number;
    AddressID?: string;
    Title?: string;
    BankAccount?: string;
    Date?: Date;
    FineScript?: string;
    User?: string;
    Password?: string;
    Token?: string;
} 